import axios from 'axios';

const baseUrl =
    process.env.REACT_APP_QCX_API_BASE_URL! + '/' + process.env.REACT_APP_QCX_API_SOLICITACAO_PAGAMENTO_ENDPOINT + '/' + 'relatorio/solicitacao-pagamento';

export const generateSolicitacaoPagamentoReport = async (
    token: string,
    unidadeId: string,
    tenantIds: string[],
    clientIds: string[],
    fornecedorId: string,
    tipo: string,
    status: string,
    bancoId: number | null,
    despesaId: string,
    lancto: { inicio: string, fim: string },
    venc: { inicio: string, fim: string },
    pago: { inicio: string, fim: string },
    processIds: string[]
): Promise<string | null> => {
    const params = new URLSearchParams();

    params.set('tenantIds', tenantIds.join(','));

    if (clientIds.length > 0) params.set('clientesIds', clientIds.join(','));
    if (processIds.length > 0) params.set('processosIds', processIds.join(','));
    if (fornecedorId) params.set('fornecedorId', fornecedorId);
    if (despesaId) params.set('despesaId', despesaId);
    if (bancoId) params.set('bancoId', bancoId.toString());
    
    if (tipo && tipo !== 'TODOS') params.set('tipoSolicitacao', tipo);
    if (status && status !== 'TODOS') params.set('status', status);
    
    if (lancto.inicio && lancto.fim) params.set('lancamentoRange', `${lancto.inicio};${lancto.fim}`);
    if (venc.inicio && venc.fim) params.set('vencimentoRange', `${venc.inicio};${venc.fim}`);
    if (pago.inicio && pago.fim) params.set('pagamentoRange', `${pago.inicio};${pago.fim}`);

    try {
        const response = await axios.get(`${baseUrl}?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                quickcomexTenant: unidadeId,
            },
            responseType: 'blob',
        });

        if (response.status === 200) {
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Relatorio_Solicitacao_Pagamento.xlsx`;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            return null;
        } else {
            return 'Erro ao processar o arquivo no servidor.';
        }
    } catch (error) {
        let message = 'Erro ao gerar o relatório de Solicitação de Pagamento.';

        if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
            const text = await error.response.data.text();
            message = text || message;
        }

        return message;
    }
};